import { Component } from "react";
import { IBaseComponentProps, NSSpace, NSSpaceSizeType, NSTable, NSTitle } from "namirasoft-site-react";
import { PolicyRow } from "namirasoft-access";
import { AccessProps } from "../AccessProps";
import { NamirasoftMap } from "namirasoft-site-map";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { BaseMetaColumn, BaseMetaTable, FilterItem, FilterItemOperator, SortItem } from "namirasoft-core";
import { AccessEntities } from "../AccessEntities";

export interface PolicyTableProps extends IBaseComponentProps, NSARouterMakerResult, AccessProps
{
	id: string;
	ids: string[];
}

export default class PolicyTable extends Component<PolicyTableProps>
{
	override render()
	{
		let namirasoft = new NamirasoftMap(this.props.account.token_manager, this.props.notifier.onError);
		let entity_policy = AccessEntities.policy(this.props);
		let meta_policy = namirasoft.access.tables.policy;
		return <>
			<NSSpace size={NSSpaceSizeType.NORMAL}></NSSpace>
			<NSTitle title='Policies' />
			<NSTable<PolicyRow>
				id={this.props.id}
				name={`policies-${this.props.id}`}
				checkbox={false}
				columns={entity_policy.client.getColumns()}
				getRows={async (page: number, size: number, sorts: SortItem[]) =>
				{
					if (entity_policy.server.list)
					{
						let table = new BaseMetaTable(null, meta_policy.name, meta_policy.text);
						let column = new BaseMetaColumn(table, meta_policy.columns.id.name, meta_policy.columns.id.text, "", false);
						let filters = this.props.ids.map(id => new FilterItem(table, column, false, FilterItemOperator.all.equals, id));
						return await entity_policy.server.list(filters, page, size, sorts, null);
					}
					return { count: 0, rows: [] };
				}}
				getRowKey={e => e.value.id}
                style={{ height: "auto"}}
			/>
		</>;
	}
}